import * as React from 'react';
import * as Yup from 'yup';
import SaleHeader from './SaleHeader';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import FormikForm from '~/lib/forms/FormikForm';
import Button from '~/common/elements/mobile/Button';
import {buttonColor, buttonSize, buttonStyle} from '~/common/elements/mobile/consts';
import {emailRegExp, phoneRegExp} from '~/apps/shared/consts';

const saleSchema = Yup.object().shape({
  phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  email: Yup.string().matches(emailRegExp, 'Email is not valid'),
});

type Props = {
  result: any,
  onBack: any,
  onHelp: any,
  actionKeyBack: number,
  onView: (saleId) => void;
}

const SaleStepProcessingResult = (props: Props) => {
  const { onBack, onHelp, result, actionKeyBack, onView } = props;

  const handleSaleView = () => {
    onView(result.id);
  };

  return (
    <FormikForm
      validationSchema={saleSchema}
      render={() => (
        <PageMobileWrapper>
          <SaleHeader
            onBack={onBack}
            onHelp={() => onHelp(actionKeyBack)}
            title="Processing"
          />

          <BodyWrapper>
            <div className="m__body__titl--lg">Checkout information was sent to a driver.</div>
          </BodyWrapper>

          <FooterWrapper>
            <Button
              title="done"
              buttonStyle={buttonStyle.OUTL_LITE}
              buttonSize={buttonSize.XLG}
              buttonColor={buttonColor.PRIM}
              onClick={handleSaleView}
            />
          </FooterWrapper>
        </PageMobileWrapper>
      )}
    />
  );
};

export default SaleStepProcessingResult;
